export default `<svg width="384" height="450" viewBox="0 0 384 450" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M73 8.00005C58.2 -1.09995 39.6 -1.39995 24.5 7.10005C9.4 15.6001 0 31.6001 0 49.0001V401C0 418.4 9.4 434.4 24.5 442.9C39.6 451.4 58.2 451 73 442L361 266C375.3 257.3 384 241.8 384 225C384 208.2 375.3 192.8 361 184L73 8.00005Z" fill="currentColor"/>
</svg>
`